"<template>
  <div id="app">
    <mainPage v-if="!$store.state.user" ></mainPage>
    <dashboard v-else  ></dashboard>
  </div>
</template>

<script>
import Dashboard from './Components/Dashboard.vue'
import MainPage from './Components/MainPage.vue'
import Defaults from './config/Defaults'
import axios from 'axios'

export default {
  name: 'app',
  components: {MainPage,Dashboard},
  
  data () {
    return {
      
    }
  },
  mounted(){

    
   
},
  methods: {
    
    
      
    
    
    
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue